import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconZoomIn';
/** Renders an SVG icon. */
const SvgZoomIn = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M27.707 27.707a1 1 0 0 0 0-1.414l-5.254-5.254A10.96 10.96 0 0 0 25 14c0-6.075-4.925-11-11-11S3 7.925 3 14s4.925 11 11 11a10.96 10.96 0 0 0 7.04-2.547l5.253 5.254a1 1 0 0 0 1.414 0M14 23a9 9 0 1 1 0-18 9 9 0 0 1 0 18m0-4a1 1 0 0 0 1-1v-3h3a1 1 0 1 0 0-2h-3v-3a1 1 0 1 0-2 0v3h-3a1 1 0 1 0 0 2h3v3a1 1 0 0 0 1 1"
      />
    </svg>
  );
};
SvgZoomIn.displayName = displayName;
export default SvgZoomIn;
